// extracted by mini-css-extract-plugin
export default {"settings":"OrgSettings_settings__WucD8","settings__title":"OrgSettings_settings__title__J8uON","settings__subTitle":"OrgSettings_settings__subTitle__ri-IX"};